<template>
  <div class="uploadImg_component" v-if="isshow_uploadDialog">
    <div v-if="page == 1">
      <div class="img_box">
        <el-tabs v-model="activeName" type="card" style="height: 650px">
          <el-tab-pane label="我的图片" name="myPhoto">
            <div class="zent-btn-primary zent-btn" @click="uploadImg">上传图片</div>
            <el-checkbox
              @change="totalChange"
              v-model="totalClick"
              style="margin-right: 20px; margin-left: 20px"
              >当页全选</el-checkbox
            >
            <el-button class="zent-btn-primary zent-btn" @click="updateCates"
              >修改分组</el-button
            >
            <div>
              <el-tabs v-model="editableTabsValue" type="card" @tab-click="handleClick">
                <el-tab-pane
                  :key="item.name"
                  v-for="item in tabsList"
                  :label="item.name"
                  :id="item.tagId"
                  :name="item.name"
                >
                  <!--
                        @mouseenter="editHover(index, item)"
                        @mouseleave="editLeaver(index, item)"
                       -->
                  <div class="imgList" v-if="imgList.length > 0">
                    <div
                      class="image-item"
                      v-for="(item, index) in imgList"
                      :key="item.recordId"
                      :class="{
                        attachment_selected: rSelect.indexOf(item) != -1,
                      }"
                      @click="chooseImg(item, index)"
                    >
                      <img :src="item.image" alt="" class="single-img" />
                      <div class="flex-row-between">
                        <div>
                          <el-checkbox
                            @change="commidityClick(item, index)"
                            v-model="item.click"
                          ></el-checkbox>
                        </div>
                        <div>
                          <img
                            class="del-icon"
                            src="@/assets/img/setting/del.jpg"
                            @click="onDeleteImg(item)"
                          />
                        </div>
                      </div>
                      <!-- <img
                        src="@/assets/img/setting/del-icon.png"
                        class="del-icon"
                        v-show="index == idx"
                        @click="onDeleteImg(item)"
                      /> -->
                      <!-- <div class="delete-mask" v-show="index == idx"></div> -->
                    </div>
                  </div>
                  <div v-else>暂无数据</div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div
              v-if="imgList.length > 0"
              class="block"
              style="float: right; margin-top: 10px"
            >
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNo"
                :page-size="queryInfo.row"
                layout="total, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="编辑分类" name="opereCate">
            <div
              class="zent-btn-primary zent-btn"
              style="margin: 20px 0"
              @click="addCate"
            >
              新增分类
            </div>
            <el-table :data="tabsList1" max-height="500">
              <el-table-column prop="name" label="分类名称"></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    class="zent-btn-edit edit-delete-btn"
                    @click="updateCate(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    class="zent-btn-delete edit-delete-btn"
                    @click="deleteCate(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div
          style="position: absolute; bottom: 10px; left: 45%"
          v-show="activeName == 'myPhoto'"
        >
          <button
            class="zent-btn-primary zent-btn-large zent-btn"
            @click="confirm_uploadOnline"
          >
            确定
          </button>
        </div>
        <div class="zent-dialog-r-close" @click="close_uploadDialog">×</div>
      </div>
    </div>
    <div class="upload_localImg" v-if="page == 2">
      <div class="zent-tabs-tab-inner">
        <span
          class="return-materials"
          @click="(page = 1), (form.cateId = ''), (goodsImage2 = [])"
          >我的图片</span
        >
        <span> / 本地上传</span>
      </div>
      <div class="zent-dialog-r-close" @click="close_uploadDialog">×</div>
      <div style="padding-top: 40px; box-sizing: border-box">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="上传至分组：">
            <el-select
              v-model="form.cateId"
              popper-class="img-group-select"
              placeholder="请选择"
              style="width: 300px"
              @change="onChange_cateId"
            >
              <el-option
                v-for="item in tabsList1"
                :key="item.tagId"
                :label="item.name"
                :value="item.tagId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="网络图片：">
                  <el-input v-model="form.name" style="width:480px;"></el-input>
                  <button class="zent-btn-primary-outline zent-btn">提取</button>
                </el-form-item> -->
          <el-form-item label="本地图片：">
            <div
              style="
                width: 650px;
                height: 329px;
                overflow-y: scroll;
                display: flex;
                flex-wrap: wrap;
              "
            >
              <el-upload
                ref="upload"
                :multiple="true"
                action="/ImageServer/YmUpload_image"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-exceed="onExceedLimit"
                :on-change="handleEditChange"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccess"
                :file-list="fileList"
                accept=".JPG,.png,.GIF"
                :limit="20"
                :class="{ hide: hideUpload }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <!-- <div v-for="item in goodsImage2" :key="item">
                            <img :src="item" style="width:148px;height:148px;" />
                        </div>
                        <input type="file" id="file" multiple="multiple" @change="handleFile"> -->
            </div>
          </el-form-item>
          <!-- <el-form-item>
                    <div v-for="item in percentageList" :key="item.id">
                        <el-progress :percentage="item.percentage"></el-progress>
                    </div>
                </el-form-item> -->
        </el-form>
      </div>
      <div style="position: absolute; bottom: 0; left: 45%">
        <button
          class="zent-btn-primary zent-btn-large zent-btn"
          @click="upload_localImg1"
        >
          确认
        </button>
      </div>
    </div>
    <div class="mask" v-if="isshow_uploadDialog"></div>
    <!-- 修改分组 -->
    <div class="mask1" v-if="mask"></div>
    <div class="update-cate" v-if="cateDialogVisible">
      <div class="flex-row-between dialog-title">
        <div>修改分组</div>
        <div
          class="zent-dialog-r-close"
          @click="(cateDialogVisible = false), (mask = false)"
        >
          ×
        </div>
      </div>
      <div style="padding-top: 20px; box-sizing: border-box">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="上传至分组：">
            <el-select
              v-model="form.cateId"
              popper-class="img-group-select"
              placeholder="请选择"
              style="width: 300px"
              @change="onChange_cateId"
            >
              <el-option
                v-for="item in tabsList1"
                :key="item.tagId"
                :label="item.name"
                :value="item.tagId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right; margin: 180px 40px 0 0">
            <el-button
              class="zent-btn-primary zent-btn-large zent-btn"
              @click="update_imgCate"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getImgList,
  getTagsList,
  updateTag,
  removeTag,
  addTag,
  uploadImg,
  removeImg,
  addImg,
  imgListTotalNum,
  uploadFile,
  UserImageBox_moveImg,
} from "@/api/index";
export default {
  props: {
    isshow_uploadDialog: Boolean,
    ImgLimits: Number,
    uploadName: String,
  },
  data() {
    return {
      value: "",
      list: [
        { name: "我的图片", id: 1 },
        { name: "编辑分类", id: 2 },
        { name: "新增分类", id: 3 },
      ],
      activeName: "myPhoto",
      editableTabsValue: "全部",
      tabIndex: 0,
      tabsList: [{ name: "全部", tagId: "" }],
      tabsList1: [],
      tabsList2: [
        { name: "测试用图片不能删除", tagId: 1 },
        { name: "第二", tagId: 2 },
      ],
      imgList: [],
      queryInfo: {
        pageNo: 1,
        row: 24,
      },
      total: 0,
      page: 1,
      form: {
        name: "",
        cateId: "",
        goodsImages: "",
      },
      cateList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      recordId: [],
      fileList: [],
      goodsImage1: [],
      goodsImage2: [],
      timer: null,
      start: false,
      id: "",
      rSelect: [],
      idx: null,
      hideUpload: false,
      uploadNum: 0,
      lastTime: 0,
      percentage: 0,
      percentageList: [],
      totalClick: false,
      trueCommodity: [],
      cateDialogVisible: false,
      mask: false,
    };
  },
  mounted() {
    // this.start = true
    this.getImgList();
    this.getTagsList();
  },
  // watch: {
  //     start(val) {
  //         console.log(val)
  //         if (val) {
  //             this.timer = setInterval(() => {
  //                 this.getImgList(this.id)
  //             }, 1000)
  //         } else {
  //             clearInterval(this.timer)
  //         }
  //     }
  // },
  destroyed() {
    // clearInterval(this.timer)
  },
  methods: {
    getTagsList(tagId, name) {
      getTagsList({
        shopId: localStorage.shopId,
        tagId: tagId,
        name: name,
        pageNumber: 1,
        pageSize: 999,
      }).then((res) => {
        if (res.code == 1) {
          this.tabsList = JSON.parse(JSON.stringify(res.data));
          this.tabsList.unshift({ name: "全部", tagId: "" });
          this.tabsList1 = JSON.parse(JSON.stringify(res.data));
          // console.log(this.tabsList1, 11111);
        } else if (res.code == -1) {
          this.tabsList1 = [];
          this.tabsList = [];
          this.tabsList.unshift({ name: "全部", tagId: "" });
        } else {
        }
      });
    },
    close_uploadDialog() {
      this.$emit("onClose");
      this.page = 1;
      this.form.cateId = "";
      this.goodsImage2 = [];
      this.trueCommodity.forEach((item) => {
        item.click = false;
      });
      this.trueCommodity = [];
    },
    handleClick(e) {
      this.queryInfo.pageNo = 1;
      this.id = e.$attrs.id;
      if (!this.id) {
        this.start = true;
      }
      this.getImgList(this.id);
    },
    updateCates() {
      if (this.trueCommodity.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择图片",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      this.cateDialogVisible = true;
      this.mask = true;
    },
    update_imgCate() {
      this.$confirm("您确定要修改该图片的分组吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        // console.log(this.trueCommodity, "update_imgCate")
        var recordIds = this.trueCommodity.map((item) => item.recordId).join(",");
        // console.log(recordIds, "recordIds")
        UserImageBox_moveImg({
          tagId: this.form.cateId,
          recordIds,
        }).then((res) => {
          if (res.code == 1) {
            this.cateDialogVisible = false;
            this.mask = false;
            this.trueCommodity = [];
            this.form.cateId = "";
            this.$notify({
              title: "提示",
              message: "修改成功",
              type: "success",
              duration: 1000,
            });
            this.getImgList();
          }
        });
      });
    },
    totalChange() {
      // console.log(this.ImgLimits, this.rSelect);
      // if(this.ImgLimits < 24) {
      //   this.$notify.warning(`不能全选，最多能选${this.ImgLimits}张哦`)
      //   this.totalClick = false
      //   return
      // }
      this.imgList.forEach((element) => {
        element.click = this.totalClick;
      });
      console.log(this.totalClick, "totalClick");
      if (this.totalClick) {
        this.trueCommodity = [];
        this.imgList.forEach((element) => {
          this.trueCommodity.push(element);
        });
        console.log(this.trueCommodity, "全选");
        // this.rSelect = this.trueCommodity
      } else {
        this.trueCommodity = [];
      }
    },
    commidityClick(item, index) {
      console.log(item, index);
      var arr = this.imgList;
      var trueCommodity = this.trueCommodity;
      console.log(item.click, "是否选中状态");
      if (item.click == false) {
        this.totalClick = false;
        // this.trueCommodity.splice(i, 1)
        for (let i in this.trueCommodity) {
          if (this.trueCommodity[i].recordId == item.recordId) {
            trueCommodity.splice(i, 1);
          }
        }
      } else {
        this.totalClick = arr.every((item1) => {
          return item1.click;
        });
        trueCommodity.push(item);
      }
      // console.log(this.trueCommodity, 'this.trueCommodity');
      this.imgList = "";
      this.imgList = arr;
      this.trueCommodity = trueCommodity;
    },
    getImgList(tagId) {
      getImgList({
        tagId: tagId,
        pageNumber: this.queryInfo.pageNo,
        pageSize: this.queryInfo.row,
      }).then((res) => {
        imgListTotalNum({
          tagId: tagId,
        }).then((res) => {
          if (res.code == 1) {
            this.total = res.data.totalNum;
          } else {
            this.total = 0;
          }
        });
        if (res.code == 1) {
          this.imgList = res.data;
          for (var i in this.imgList) {
            this.imgList[i].click = false;
          }
          // if (this.queryInfo.pageNo > 1) {
          //     this.imgList = [...this.imgList, ...res.data]
          //     this.total = this.imgList.length
          //     this.queryInfo.pageNo += 1
          //     if (res.data.length < this.queryInfo.row) {
          //         this.start = false
          //         this.queryInfo.pageNo = 1
          //         clearInterval(this.timer)
          //     }
          // } else {
          //     this.imgList = res.data
          //     this.total = this.imgList.length
          //     this.queryInfo.pageNo += 1
          //     this.start = true
          //     if (res.data.length < this.queryInfo.row) {
          //         this.start = false
          //         clearInterval(this.timer)
          //     }
          // }
        } else if (res.code == -1) {
          this.imgList = [];
          this.total = 0;
          // this.start = false
          // clearInterval(this.timer)
        } else {
          // this.start = false
          // clearInterval(this.timer)
        }
      });
    },
    chooseImg(item, index) {
      let ImgLimits = this.ImgLimits;
      console.log(this.ImgLimits, this.rSelect);
      if (ImgLimits == 1) {
        if (this.rSelect.length >= 1) {
          this.rSelect = [];
          this.rSelect.push(item);
        } else {
          this.rSelect.push(item);
        }
        return;
      }
      if (this.rSelect.indexOf(item) !== -1) {
        this.rSelect.splice(this.rSelect.indexOf(item), 1); //取消
      } else {
        if (this.rSelect.length && this.rSelect.length >= ImgLimits) {
          this.$notify({
            title: "提示",
            message: "只能上传" + ImgLimits + "张",
            type: "success",
            duration: 1000,
          });
          return;
        }
        this.rSelect.push(item); //选中添加到数组里
      }
    },
    editHover(idx, item) {
      // console.log(idx, item);
      this.idx = idx;
    },
    editLeaver(idx, item) {
      // console.log(idx, item);
      this.idx = null;
    },
    handleCurrentChange(val) {
      this.queryInfo.pageNo = val;
      if (this.id) {
        this.getImgList(this.id);
      } else {
        this.getImgList();
      }
    },
    uploadImg() {
      this.page = 2;
    },
    onChange_cateId(val) {
      this.form.cateId = val;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.hideUpload = fileList.length >= 20;
      console.log(file, fileList);
      this.goodsImage1 = [];
      this.goodsImage1.push(file.url);
      this.goodsImage2 = [];
      fileList.forEach((item) => {
        console.log(item);
        let imgUploadForm = new FormData();
        imgUploadForm.append("file", item.raw);
        imgUploadForm.append("fileContentType", item.raw.type);
        imgUploadForm.append("fileFileName", item.raw.name);
        imgUploadForm.append("isCompre", 1);
        imgUploadForm.append("isCutImage", 1);
        uploadImg(imgUploadForm).then((res) => {
          if (res.code == 1) {
            var bool = this.goodsImage2.every((item) => {
              return item !== res.data.url;
            });
            if (bool) {
              this.goodsImage2.push(res.data.url);
              console.log(this.goodsImage2, "新增2");
            }
          }
        });
      });
      console.log(this.goodsImage1, "删掉的");
      console.log(this.goodsImage2, "没被删掉的");
    },
    onExceedLimit(files, fileList) {
      if (files.length > 20) {
        this.$notify({
          title: "警告",
          message: "上传失败，一次只能上传20张图片哦~",
          type: "warning",
          duration: 2000,
        });
      }
    },
    beforeImgUplod(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
      }
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    handleEditChange(file, fileList) {
      this.uploadNum = 0;
      this.uploadNum = fileList.length;
      this.hideUpload = fileList.length >= 20;
    },
    upload_localImg1() {
      // this.percentageList = []
      let now = new Date().valueOf();
      if (this.lastTime == 0) {
        console.log("触发事件");
        this.upload_localImg();
        this.lastTime = now;
      } else {
        if (now - this.lastTime > 3000) {
          this.lastTime = now;
          console.log("间隔大于3秒，触发方法");
          this.upload_localImg();
        } else {
          console.log("不触发");
        }
      }
    },
    upload_localImg() {
      // console.log(this.form, 1111)
      // console.log(this.goodsImage1, "goodsImage1")
      // console.log(this.goodsImage2, "goodsImage2")
      console.log(this.uploadNum, "this.uploadNum", this.goodsImage2.length);
      if (this.uploadNum !== this.goodsImage2.length) {
        this.$message.warning("图片还未全部上传完成，请稍等~");
        return;
      }
      // return
      this.form.goodsImages = "";
      this.goodsImage2.forEach((item) => {
        this.form.goodsImages += `,${item}`;
        // this.form.goodsImages += ',' + item + ',';
        // this.form.goodsImages = this.form.goodsImages.substring(0, this.form.goodsImages.lastIndexOf(','));
      });
      // if (this.form.goodsImages.substr(0,1)==',')  this.form.goodsImages = this.form.goodsImages.substr(1);
      // if (this.form.cateId) {
      if (this.goodsImage2.length <= 1) {
        if (!this.form.goodsImages) {
          this.$message.warning("请选择您要上传的图片");
          return;
        }
      } else {
      }
      // } else {
      //   this.$message.warning("请选择您要上传的分组");
      //   return;
      // }

      addImg({
        tagId: this.form.cateId,
        images: this.form.goodsImages,
      }).then((res) => {
        if (res.code == 1) {
          this.page = 1;
          this.form = {};
          this.editableTabsValue = "全部";
          this.goodsImage2 = [];
          this.lastTime = 0;
          this.getImgList();
          this.$message.success({
            message: "上传成功",
            icon: "success",
            duration: 1000,
          });
        }
      });
    },
    // handleFile(res) {
    //     const files = res.target.files
    //     const file = Array.from(files)
    //     console.log(res.target.files)
    //     if(files) {
    //         file.forEach(item => {
    //             let imgUploadForm = new FormData();
    //             imgUploadForm.append("file", item);
    //             imgUploadForm.append("fileContentType", item.type);
    //             imgUploadForm.append("fileFileName", item.name);
    //             imgUploadForm.append("isCompre", 1);
    //             imgUploadForm.append("isCutImage", 1);
    //             uploadImg(imgUploadForm).then((res) => {
    //                 if (res.code == 1) {
    //                     // this.form.goodsImages = res.data.url;
    //                     console.log(this.goodsImage2, "goodsImage2")
    //                     var bool = this.goodsImage2.every(item => {
    //                         return item !== res.data.url
    //                     })
    //                     console.log(res.data.url, "res.data.url")
    //                     if (bool) {
    //                         this.goodsImage2.push(res.data.url)
    //                         console.log(this.goodsImage2, "新增1")
    //                     }
    //                 }
    //             });
    //         })
    //     }
    // },
    handleSuccess(res) {
      console.log(res);
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.form.goodsImages = res.data.url;
          // this.addDialog.uploadIdList = []
          // fileList.forEach((item) => {
          //     if (item.response && item.response.code === 200) {
          //         this.goodsImage2.push(item.response.data)
          //     }
          //     return
          // })
          console.log(this.goodsImage2, "goodsImage2");
          var bool = this.goodsImage2.every((item) => {
            return item !== res.data.url;
          });
          console.log(res.data.url, "res.data.url");
          if (bool) {
            this.goodsImage2.push(res.data.url);
            console.log(this.goodsImage2, "新增1");
          }
        }
      });
    },
    deleteCate(row) {
      this.$confirm("此操作将永久删除该分类, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        removeTag({
          tagId: row.tagId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getTagsList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    updateCate(row) {
      console.log(row);
      this.$prompt("请输入新的分类名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "text",
        inputValue: row.name,
      }).then(({ value }) => {
        updateTag({
          tagId: row.tagId,
          name: value,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "修改成功",
              type: "success",
              duration: 1000,
            });
            this.getTagsList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    addCate() {
      this.$prompt("请输入分类名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "text",
        customClass: "img-up-prompt",
      }).then(({ value }) => {
        addTag({
          name: value,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "添加成功",
              type: "success",
              duration: 1000,
            });
            this.getTagsList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    confirm_uploadOnline() {
      console.log(this.rSelect, this.uploadName, "confirm_uploadOnline");
      // return
      if (this.rSelect && this.rSelect.length > 0) {
        this.$emit("getChoose_ImgUrl", this.rSelect, this.uploadName);
      } else {
        this.$notify({
          title: "提示",
          message: "请先选择图片",
          type: "warning",
          duration: 1000,
        });
      }
    },
    onDeleteImg(row) {
      this.trueCommodity = [];
      this.$confirm("此操作将永久删除该照片, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        removeImg({
          recordId: row.recordId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.rSelect = [];
            this.editableTabsValue = "全部";
            this.getImgList();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.uploadImg_component {
  .edit-delete-btn {
    min-width: 74px;
    display: inline-block;
    height: 32px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    color: #fff;
    border: 1px solid #dcdee0;
    text-align: center;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    margin: 0 10px;
  }
  .zent-btn-edit {
    background-color: #409eff;
  }
  .zent-btn-delete {
    background-color: #f56c6c;
    margin-left: 20px;
  }
  .zent-dialog-r-close {
    position: absolute;
    display: inline-block;
    top: 13px;
    right: 15px;
    color: #c8c9cc;
    font-size: 20px;
    line-height: 20px;
    text-align: right;
    vertical-align: middle;
    cursor: pointer;
    border: 0;
    background-color: #fff;
    outline: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0 6px;
    margin: 0;
  }
  .zent-btn {
    min-width: 74px;
    display: inline-block;
    height: 32px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    color: #fff;
    background: var(--c_main, #8558fa);
    border: 1px solid #dcdee0;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;
    margin: 20px 0;
  }
  .zent-btn-large {
    padding: 0 24px;
    height: 40px;
    line-height: 38px;
    font-size: 16px;
  }
  button {
    appearance: none;
    border: none;
    background-color: transparent;
    outline: none;
  }
  .upload_localImg {
    width: 850px;
    height: 550px;
    padding: 20px;
    background: #fff;
    position: absolute;
    z-index: 3000;
    border-radius: 6px;
    top: 100px;
    left: 25%;
    .zent-tabs-tab-inner {
      padding: 8px 15px;
      cursor: pointer;
      width: 170px;
      position: relative;
      box-sizing: border-box;
      font-size: 14px;
      border: 1px solid #ebedf0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom: none;
      &::after {
        width: 682px;
        border-bottom: 1px solid #ebedf0;
        content: "";
        display: inline-block;
        position: absolute;
        left: 168px;
        top: 34px;
      }
      .return-materials {
        color: #8558fa;
        &::before {
          width: 8px;
          height: 8px;
          border-left: 1px solid #8558fa;
          border-top: 1px solid #8558fa;
          display: inline-block;
          content: "";
          transform: rotate(-45deg);
        }
      }
    }
    .zent-btn-primary-outline {
      color: var(--c_main, #8558fa);
      border-color: var(--c_main, #8558fa);
      background-color: #fff;
      margin-left: 20px;
    }
  }
  .img_box {
    width: 990px;
    height: 650px;
    padding: 20px;
    background: #fff;
    position: absolute;
    z-index: 3000;
    border-radius: 6px;
    top: 100px;
    left: 25%;
    .zent-tabs-tab-inner {
      padding: 8px 15px;
      cursor: pointer;
      width: 90px;
      position: relative;
      box-sizing: border-box;
      font-size: 14px;
      border: 1px solid #ebedf0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      border-bottom: none;
      &::after {
        width: 900px;
        border-bottom: 1px solid #ebedf0;
        content: "";
        display: inline-block;
        position: absolute;
        left: 89px;
        top: 33px;
      }
    }
    .imgList {
      width: 100%;
      height: auto;
      max-height: 390px;
      overflow-y: G;
      display: flex;
      flex-wrap: wrap;
      .image-item {
        width: 105px;
        height: 115px;
        background: rgba(0, 0, 0, 0.6);
        margin-right: 15px;
        margin-bottom: 40px;
        position: relative;
        &.attachment_selected {
          position: relative;
          top: 0;
          left: 0;
          width: 109px;
          height: 119px;
          border: 2px solid #07d;
          box-sizing: border-box;
          border-color: var(--c_main, #8558fa);
          z-index: 9;
          // &::after {
          //     position: absolute;
          //     bottom: 0;
          //     right: 0;
          //     background-color: var(--c_main, #8558fa);
          //     width: 0;
          //     height: 0;
          //     border-left: 20px solid #8558fa;
          //     border-top: 20px solid transparent;
          //     border-bottom: 20px solid transparent;
          // }
        }
        .single-img {
          width: 105px;
          height: 115px;
        }
        .del-icon {
          width: 20px;
          height: 20px;
          margin-top: 3px;
          cursor: pointer;
          // position: absolute;
          // top: 37px;
          // right: 31px;
          // z-index: 3;
        }
        .delete-mask {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 2;
        }
      }
    }
    .zent-btn-primary {
      color: #fff;
      background: var(--c_main, #8558fa);
      border-color: var(--c_main, #8558fa);
    }
  }
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
  }
  .mask1 {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 3000;
  }
  .update-cate {
    width: 680px;
    height: 400px;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    top: 10%;
    left: 35%;
    z-index: 3001;
    padding: 20px;
    box-sizing: border-box;
    .dialog-title {
      border-bottom: 1px solid #ececec;
    }
  }
}
.el-tabs__content {
  position: none;
}
</style>
<style>
.img-group-select,
.el-message-box__wrapper {
  z-index: 3001 !important;
}
</style>
